class CustomersNav {
	constructor(el) {
		this.init(el);
	}

	init(el) {
		this.container = el;

		if (!this.container) {
			return;
		}

		this.container.querySelector('.customers-nav__opener').addEventListener('click', () => {
			this.container.classList.toggle('_opened');
		});
		this.container.querySelector('.customers-nav__list').addEventListener('click', () => {
			this.container.classList.remove('_opened');
		});

		window.addEventListener('click', (evt) => {
			if (this.container.contains(evt.target)) {
				return;
			}

			this.container.classList.remove('_opened');
		});
	}
}

document.querySelectorAll('[data-customers-nav]').forEach((el) => new CustomersNav(el));

export default CustomersNav;
